import CONSTANTS from "../../constants";
import fetchWithAuthorizationHeader from "../../helper/fetchWithAuthorizationHeader";
import { UpdateGcpCertApprovalStatus } from "../../types/gcpCert";

const { GCPCERTS_API_URL } = CONSTANTS;

const updateCertApprovers = async (updateApprovers: UpdateGcpCertApprovalStatus): Promise<any> => {
  const response = await fetchWithAuthorizationHeader(`${GCPCERTS_API_URL}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      action: 'UPDATE'
    },
    body: JSON.stringify(updateApprovers)
  });

  return response.json();
};

export default updateCertApprovers;
